module.exports = __webpack_public_path__ + "static/media/home-purchasing.9fd94343.jpg";